<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :newLayout="true"
        :hideFooter="false"
    >
        <template slot="card-header">
            <slot name="header"></slot>
        </template>
        <template slot="card-body">
            <slot name="body-title"></slot>
            <form
                ref="form"
                method="POST"
                :action="$laraRoute('enrol')"
                @submit.prevent="handleForm"
                id="enrol-form"
                novalidate
            >
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="mobile"
                        class="col-md-3"
                        v-translate
                    >Phone</label>

                    <PhoneInput
                        @change="setMobile"
                        :value="mobile"
                        :maxlength="40"
                    />
                </div>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="experience"
                        class="col-md-3"
                        v-translate
                    >Trading Experience</label>
                    <div class="col-md-8 col-lg-7">
                        <div
                            class="tabs"
                            :class="{ 'tabs-invalid': errors.has('experience'), 'tabs-disabled': formSubmitting }"
                        >
                            <input
                                v-model="localExperience"
                                v-validate="'radioTabs'"
                                data-vv-validate-on="change"
                                id="experience_nonprof"
                                type="radio"
                                class="form-control"
                                name="experience"
                                :disabled="formSubmitting ? true : false"
                                required
                                value="Non-Professional"
                                @input="emitBusChange($event, 'experience')"
                            >
                            <label
                                class="tab"
                                for="experience_nonprof"
                                v-translate
                            >Non Professional</label>
                            <input
                                v-model="localExperience"
                                v-validate="'radioTabs'"
                                data-vv-validate-on="change"
                                id="experience_prof"
                                type="radio"
                                class="form-control"
                                name="experience"
                                :disabled="formSubmitting ? true : false"
                                required
                                value="Professional"
                                @change="emitBusChange($event, 'experience')"
                            >
                            <label
                                class="tab"
                                for="experience_prof"
                                v-translate
                            >Professional</label>
                        </div>
                        <InlineError
                            :errors="errors"
                            type="experience"
                        />
                    </div>
                </div>
                <!-- DEVTODO - hook up to Salesforce -->
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="residency_country"
                        class="col-md-3"
                        v-translate
                    >Country you are resident for tax purposes</label>
                    <div
                        class="col-md-8 col-lg-7"
                        v-if="countries.length"
                    >
                        <CountrySelect
                            :required="true"
                            :options="countries"
                            :hasValue="countryOfResidence ? countryOfResidence : false"
                            :setCountry="setResidencyCountry"
                            :getIsoCodeFromName="getIsoCodeFromName"
                            :label="'residency_country'"
                            :handler="countryHandler"
                        >
                            <template slot-scope="{slotKey}">
                                <span
                                    :data-key="slotKey"
                                    :class="`iti-flag ${slotKey.toLowerCase()}`"
                                ></span>&nbsp;
                            </template>
                        </CountrySelect>
                    </div>
                    <div
                        class="col-md-8 col-lg-7 loader loader--inline"
                        v-else
                    >
                        <loader />
                    </div>
                </div>
            </form>
        </template>
        <template slot='card-footer'>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
            <slot
                name="footer"
                :submitForm="submitForm"
                :isValid="isValid"
            ></slot>
        </template>
    </Card>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { log } from 'util';

import Card from '@C/Card';
import PhoneInput from '@C/PhoneInput';
import CountrySelect from '@C/CountrySelect';
import Input from '@C/Forms/Input';
import InlineError from '@C/Forms/InlineError';
import FlashMessage from '@C/FlashMessage';

import validator from '@M/validationWrapper';

import { emptyOrStringValidator } from '@H/validation';

export default {
    name: 'ExtraDetails',
    created() {
        this.getOrganisedCountries();
        this.localExperience = this.experience;

        this.setMobile(this.mobile);
    },
    data() {
        return {
            localExperience: ''
        }
    },
    props: {
        experience: {
            validator: emptyOrStringValidator,
            requried: true
        },
        mobile: {
            validator: emptyOrStringValidator,
            required: true
        },
        setMobile: {
            type: Function,
            required: true
        },
        setResidencyCountry: {
            type: Function,
            required: true
        },
        countryOfResidence: {
            validator: emptyOrStringValidator,
            required: true
        },
        getIsoCodeFromName: {
            type: Function,
            required: true
        }
    },
    computed: {
        ...mapState(['formSubmitting', 'countries', 'bus']),
    },
    methods: {
        ...mapActions({
            getOrganisedCountries: 'getOrganisedCountries',
        }),
        emitBusChange(e, key) {
            this.bus.$emit('update:detail', { value: e.target.value, key });
        },
        submitForm() {
            this.$refs.form.dispatchEvent(
                new Event('submit', { cancelable: true })
            );
        },
        countryHandler(e, firstRun = false) {
            let val = e.value || e.target.value;
            this.getIsoCodeFromName(val, this.countries);
            this.setResidencyCountry(val);
        }
    },
    components: {
        Card,
        PhoneInput,
        CountrySelect,
        Input,
        InlineError,
        FlashMessage
    },
    mixins: [validator]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Enrolment/ExtraDetails.vue